import { createContext, useContext } from 'react';

import type { BlockCreatorStepId } from '../types';

export interface BlockCreatorContextValue {
  goToStep: (stepId: BlockCreatorStepId) => void;
  onPrevStep: () => void;
  handleCancel: () => void;
}

export const BlockCreatorContext = createContext<BlockCreatorContextValue | null>(null);

export const useBlockCreator = () => {
  const context = useContext(BlockCreatorContext);

  if (!context) {
    throw new Error(`"BlockCreatorProvider" must be present in React DOM tree`);
  }

  return context;
};
